var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#121212",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7803 23.7198L23.263 22.2025C24.3883 20.8948 25.0047 19.2253 24.9993 17.5C24.9993 14.4318 23.1452 11.9103 20.5 10.75V12.25C22.2903 13.2895 23.4993 15.2853 23.4993 17.5C23.496 18.8325 23.0554 20.127 22.2452 21.1848L21.2815 20.221C21.733 19.402 22 18.3925 22 17.5C22 16.1718 21.4188 14.575 20.5 13.75V19.4395L19 17.9395V11.5C18.9999 11.3644 18.9631 11.2313 18.8933 11.1149C18.8236 10.9985 18.7236 10.9033 18.604 10.8392C18.4844 10.7752 18.3497 10.7448 18.2142 10.7513C18.0787 10.7578 17.9474 10.8009 17.8345 10.876L14.2953 13.2348L11.2803 10.2198L10.2197 11.2803L23.7197 24.7803L24.7803 23.7198ZM17.5 12.901V16.4395L15.3767 14.3163L17.5 12.901ZM11.5 21.25H13.5228L17.8337 24.124C17.9468 24.1991 18.0781 24.2423 18.2137 24.2489C18.3493 24.2555 18.4842 24.2253 18.604 24.1615C18.7237 24.0974 18.8238 24.0021 18.8935 23.8856C18.9632 23.7691 19.0001 23.6358 19 23.5V22.0908L17.5 20.5908V22.099L14.1662 19.876C14.1475 19.8633 14.1243 19.861 14.1048 19.8513C14.0162 19.8031 13.9187 19.7734 13.8183 19.7643C13.7943 19.762 13.774 19.75 13.75 19.75H11.5V15.25H12.1593L10.8265 13.9173C10.5789 14.0412 10.3706 14.2314 10.2247 14.4667C10.0787 14.702 10.001 14.9732 10 15.25V19.75C10 20.5773 10.6727 21.25 11.5 21.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMuted);
export default __webpack_public_path__ + "static/media/volume-muted.f5f65ec1f8ef13bf896106f75c9e5dc8.svg";
export { ForwardRef as ReactComponent };